import { render, staticRenderFns } from "./DashboardHeader.vue?vue&type=template&id=3ca3c15a&scoped=true&"
import script from "./DashboardHeader.vue?vue&type=script&lang=js&"
export * from "./DashboardHeader.vue?vue&type=script&lang=js&"
import style0 from "./DashboardHeader.vue?vue&type=style&index=0&id=3ca3c15a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca3c15a",
  null
  
)

export default component.exports